import type {NormalizedCacheObject} from '@apollo/client';
import type {ApolloClientProxy, BaseHttpCodes} from '@igp/shared/api';
import {GraphQLService} from '@igp/shared/api';
import type {Mutation, Query, Subscription} from '@igp/shared/contract/pam';
import {UserProfileSubscription} from '@igp/shared/features/user-profile';
import type {MessageLocalizer} from '@igp/shared/localization';
import type {EntitySubscription} from '@igp/shared/redux/realtime';
import {BaseRealtimeService} from '@igp/shared/redux/realtime';
import type {EntityType} from '@models';
import {inject, injectable} from 'inversify';

import {ServiceTypes} from '@ioc-container';

@injectable()
export class RealtimeService extends BaseRealtimeService<EntityType, Subscription> {
    constructor(
        @inject(ServiceTypes.ApolloClientIGP) client: ApolloClientProxy<NormalizedCacheObject>,
        @inject(ServiceTypes.MessageLocalizer) messageLocalizer: MessageLocalizer
    ) {
        const subscriptionMapping: Record<EntityType, EntitySubscription<Subscription>> = {
            UserProfile: new UserProfileSubscription(),
            Transaction: undefined,
            AgentLevelReportV2: undefined,
            PlayerLevelReportV2: undefined,
            Country: undefined,
            BulkOperation: undefined,
            AgentProfile: undefined,
            NegaitveCarryoverReport: undefined,
            NegativeCarryoverWeeklySummary: undefined,
            UserActivitySummary: undefined,
            PlayerBonus: undefined,
            BonusCode: undefined,
            Backpack: undefined,
            PlayerReferral: undefined,
            CountryLevelPartnerReport: undefined,
            DebtResponsibleMasterAgents: undefined,
            DebtTransferLog: undefined,
            RepaymentLog: undefined,
            PayoutReport: undefined,
            BoUser: undefined,
            BoUserGroup: undefined,
            P2PPlayerSettings: undefined,
            PlayerEcologyWeekly: undefined,
            ReferralLinkConfig: undefined,
            KeycloakLog: undefined,
        };
        super(new GraphQLService<Query, Mutation, Subscription, BaseHttpCodes>(client, messageLocalizer), subscriptionMapping);
    }
}
